import { ChevronRight } from "lucide-react";
import React from "react";
import { AnimatePresence, delay, motion } from "framer-motion";

export default function AccordionImage() {
  const [active, setActive] = React.useState(0);
  const [currentIndex, setCurrentIndex] = React.useState();

  const handleButtonClick = (e) => {
    e.preventDefault();
    console.log("button clicked");
  };
  const handleOnClick = (e) => {
    const clickedId = Number(e.currentTarget.id);
    setActive(clickedId);
    setCurrentIndex(clickedId);
    e.preventDefault();
  };

  const data = [
    {
      title: "Automate any Workflow",
      description: "Optimize your Process with simple and secured CI/CD",
      button: "Discover GitHub Actions",
      link: "#",
      image: "/couple.jpg",
    },
    {
      title: "Automate any Workflow",
      description: "Optimize your Process with simple and secured CI/CD",
      button: "Discover GitHub Actions",
      link: "#",
      image: "/logo-cloud.png",
    },
    {
      title: "Automate any Workflow",
      description: "Optimize your Process with simple and secured CI/CD",
      button: "Discover GitHub Actions",
      link: "#",
      image: "/couple.jpg",
    },
    {
      title: "Automate any Workflow",
      description: "Optimize your Process with simple and secured CI/CD",
      button: "Discover GitHub Actions",
      link: "#",
      image: "/couple.jpg",
    },
  ];

  const variants = {
    open: { height: "auto", opacity: 1, transition: { duration: 0.4, ease: "easeInOut" } },
    close: { height: 0, opacity: 0, transition: { duration: 0.4, ease: "easeInOut" } },
  };
  
  const imgVariants = {
    enter: { opacity: 0, scale: 0.95 },
    center: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: "easeOut" } },
    exit: { opacity: 0, scale: 1.05, transition: { duration: 0.3, ease: "easeOut" } },
  };
  
  return (
    <div>
      <div className="h-screen flex flex-col md:flex-row items-center justify-center gap- p-4 md:p-8 ">
        <div>
          <div className="h-[35rem] md:w-[80rem] md:grid grid-cols-12 flex flex-col   justify-center  p-4 md:p-8 ">
            <div className=" col-span-5 xl:col-span-6 xl:col-start-1 col-start-2 flex flex-col items-center justify-center gap-4">
                {data.map((content, index) => (
                  <button
                    key={index}
                    id={index}
                    onClick={handleOnClick}
                    className="group md:px-20 xl:px-10 w-full"
                  >
                    <div className="py-3">
                      <div className=" flex items-center">
                        <h3
                          className={`font-semibold group-hover:text-slate-700 duration-[400ms] ease-in transition-all text-2xl ${
                            active === index
                              ? "text-slate-700"
                              : "md:text-xl text-gray-300"
                          }`}
                        >
                          {content.title}
                        </h3>
                      </div>
                      <AnimatePresence>
  {active === index && (
    <motion.div
      key={`content-${index}`}
      variants={variants}
      initial="close"
      animate="open"
      exit="close"
      className="md:max-w-[25rem] xl:max-w-[40rem] text-left overflow-hidden"
    >
      <p className="mb-2">{content.description}</p>
      <button
        className="text-blue-700 pb-3 pt-2 font-medium"
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          handleButtonClick(e);
        }}
      >
        {content.button} <ChevronRight className="inline size-4" />
      </button>
    </motion.div>
  )}
</AnimatePresence>


                      <div></div>
                    </div>
                    <hr />
                  </button>
                ))}
            </div>

            <div className="col-span-6 h-full p-5 bg-gray-500 overflow-hidden">
  <AnimatePresence mode="popLayout">
    <motion.img
      key={data[active].image}
      variants={imgVariants}
      initial="enter"
      animate="center"
      exit="exit"
      className="w-full h-full object-cover"
      src={data[active].image}
      alt=""
    />
  </AnimatePresence>
</div>

          </div>
        </div>
      </div>
    </div>
  );
}
